import React from "react";
import { Filter, List, Clock, CheckCircle, AlertCircle } from "lucide-react";

export type TaskStatusFilterType = "ALL" | "ACTIVE" | "COMPLETED" | "OVERDUE";

interface TaskStatusFilterProps {
  selectedStatus: TaskStatusFilterType;
  onStatusChange: (status: TaskStatusFilterType) => void;
  /** Mobil overlay'de tam genişlik */
  fullWidth?: boolean;
  /** Mobil overlay'de seçim sonrası kapat */
  onClose?: () => void;
}

export default function TaskStatusFilter({ selectedStatus, onStatusChange, fullWidth = false, onClose }: TaskStatusFilterProps) {
  const statusOptions = [
    {
      key: "ALL" as TaskStatusFilterType,
      label: "Tümü",
      icon: List,
    },
    {
      key: "ACTIVE" as TaskStatusFilterType,
      label: "Aktif",
      icon: Clock,
    },
    {
      key: "COMPLETED" as TaskStatusFilterType,
      label: "Tamamlandı",
      icon: CheckCircle,
    },
    {
      key: "OVERDUE" as TaskStatusFilterType,
      label: "Süresi Geçti",
      icon: AlertCircle,
    },
  ];

  return (
    <div className={fullWidth ? "w-full" : "pr-2 w-64"}>
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <Filter className="w-4 h-4 text-gray-600" />
          <span className="text-sm font-semibold text-gray-800">Filtreler</span>
        </div>
        <div className="flex items-center gap-1" />
      </div>

      <div className="space-y-4">
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-2">Görev Durumu</label>
          <div className="space-y-1">
            {statusOptions.map((option) => {
              const Icon = option.icon;
              const isSelected = selectedStatus === option.key;

              return (
                <button
                  key={option.key}
                  onClick={(e) => {
                    e.stopPropagation();
                    onStatusChange(option.key);
                    onClose?.();
                  }}
                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-md text-sm transition-colors text-left ${isSelected ? "bg-blue-50 text-blue-700 border border-blue-200" : "text-gray-700 hover:bg-gray-100"
                    }`}>
                  <Icon className={`w-4 h-4 ${isSelected ? "text-blue-600" : "text-gray-500"}`} />
                  <span className="flex-1">{option.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}